import { useTranslation } from "react-i18next";
import { MEDIA } from "../data/site";
import { Reveal } from "../components/Reveal";
import { usePageTitle } from "../lib/usePageTitle";

const SHOTS = [
    { src: MEDIA.polishedBlack, key: "pbg_slab", h: "h-[60vh]" },
    { src: MEDIA.heroPrimary, key: "quarry_sunrise", h: "h-[70vh]" },
    { src: MEDIA.polishedBlackKitchen, key: "pbg_kitchen", h: "h-[50vh]" },
    { src: MEDIA.mfg1, key: "cutting_line", h: "h-[55vh]" },
    { src: MEDIA.polishedBlackEdges, key: "pbg_edges", h: "h-[55vh]" },
    { src: MEDIA.heroSecondary, key: "quarry_wall", h: "h-[60vh]" },
    { src: MEDIA.polishedBlackTexture, key: "pbg_texture", h: "h-[45vh]" },
    { src: MEDIA.mfg2, key: "polishing_line", h: "h-[65vh]" },
    { src: MEDIA.arch1, key: "arch_luxury", h: "h-[55vh]" },
    { src: MEDIA.arch2, key: "arch_facade", h: "h-[50vh]" },
];

export default function Gallery() {
    usePageTitle("meta.gallery");
    const { t } = useTranslation();

    return (
        <main data-testid="page-gallery" className="pt-32">
            <section className="px-6 md:px-12 lg:px-20 pt-12 pb-16">
                <Reveal>
                    <p className="text-[10px] uppercase tracking-[0.35em] text-[#C5A059]">
                        {t("gallery.overline")}
                    </p>
                    <h1 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl text-[#E8E3D9] leading-[1.02] tracking-tighter max-w-5xl">
                        {t("gallery.h1_a")}{" "}
                        <span className="italic text-[#C5A059]">
                            {t("gallery.h1_b")}
                        </span>
                    </h1>
                </Reveal>
            </section>

            <section className="px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
                <div
                    data-testid="gallery-grid"
                    className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-6 [column-fill:_balance]"
                >
                    {SHOTS.map((s, i) => {
                        const caption = t(`gallery.captions.${s.key}`);
                        return (
                            <Reveal
                                key={`${s.key}-${i}`}
                                delay={(i % 6) * 60}
                                className="mb-4 md:mb-6 break-inside-avoid"
                            >
                                <figure
                                    data-testid={`gallery-item-${i}`}
                                    className="group relative overflow-hidden bg-[#1A1A1A] border border-[#2C2C2C] hover:border-[#C5A059] transition-colors"
                                >
                                    <img
                                        src={s.src}
                                        alt={caption}
                                        className={`w-full ${s.h} object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out`}
                                    />
                                    <figcaption className="absolute inset-x-0 bottom-0 p-5 md:p-6 bg-gradient-to-t from-[#0D0D0D] to-transparent text-[10px] uppercase tracking-[0.3em] text-[#E8E3D9]">
                                        {caption}
                                    </figcaption>
                                </figure>
                            </Reveal>
                        );
                    })}
                </div>
            </section>
        </main>
    );
}
